<template>
  <div>
    <el-dialog
      title="Dodaj insemincaje"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
    >
      <span class="my-label">Wybierz datę</span>
      <el-date-picker
        v-model="inseminationDate"
        type="date"
        placeholder="Wybierz datę"
        style="width: 100%"
      ></el-date-picker>
      <el-checkbox v-model="sendInsemination" style="margin-top: 10px;">Wyślij inseminacje</el-checkbox>
      <br />
      <div v-if="sendInsemination" class="send-insemination-block">
        <el-select v-model="selectedBull" placeholder="Wybierz buhaja" style="width: 100%" filterable>
          <el-option v-for="bull in bulls" :key="bull.value" :label="bull.label" :value="bull"></el-option>
        </el-select>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">Anuluj</el-button>
        <el-button
          type="primary"
          @click="addInsemination(); dialogVisible = false"
          :disabled="!inseminationDate || (sendInsemination && !selectedBull)"
        >{{addButtonLabel}}</el-button>
      </span>
    </el-dialog>

    <div class="my-btn-panel">
      <el-row :gutter="20">
        <el-col :span="10">
          <div class="grid-content">
            <el-form>
              <el-form-item label="Aktualnie wybrana">
                <el-select
                  v-model="cow"
                  filterable
                  placeholder="Wybierz krowę"
                  v-on:change="onCowSelected"
                  value-key="number"
                >
                  <el-option
                    v-for="item in cows"
                    :key="item.number"
                    :label="item.number"
                    :value="item"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="grid-content">
            <el-button
              v-bind:class="[{'el-button--warning': cow !== null && cow.estrus.is_during}, 'my-btn']"
              @click="handleErtus()"
              :disabled="cow === null"
            >Wodzi</el-button>
          </div>
        </el-col>
        <el-col :span="5">
          <div class="grid-content">
            <el-button
              type="success"
              class="my-btn"
              @click="dialogVisible=true"
              :disabled="cow === null"
            >Dodaj inseminacje</el-button>
          </div>
        </el-col>
        <el-col :span="5">
          <div class="grid-content">
            <el-button
              type="danger"
              class="my-btn"
              @click="deleteInsemination"
              :disabled="currentRow === null"
            >Usuń inseminacje</el-button>
          </div>
        </el-col>
      </el-row>
    </div>
    <el-table
      :data="inseminationsTableData"
      style="height: 70vh; overflow: auto;"
      height="auto"
      border
      stripe
      :default-sort="{prop: 'insemination', order: 'descending'}"
      highlight-current-row
      @current-change="handleCurrentChange"
    >
      <el-table-column label="Inseminacja" prop="insemination" sortable :formatter="formatter"></el-table-column>
      <el-table-column label="Powtórka" prop="repeat" :formatter="formatter"></el-table-column>
      <el-table-column label="Zasuszać" prop="drying" :formatter="formatter"></el-table-column>
      <el-table-column label="Wycielenie" prop="toclaving" :formatter="formatter"></el-table-column>
    </el-table>
  </div>
</template>

<script>
import bus from "@/bus";
import axios from "axios";
import { serverAddress } from "../config";

export default {
  props: ["herdSettings", "cows"],
  data: function() {
    return {
      inseminationsTableData: [],
      cow: null,
      bulls: [],
      selectedBull: null,
      currentRow: null,
      dialogVisible: false,
      inseminationDate: new Date(),
      sendInsemination: true
    };
  },
  computed: {
    addButtonLabel: function() {
      return this.sendInsemination ? "Dodaj i wyślij" : "Dodaj";
    }
  },
  mounted: function() {
    bus.$on(
      "cow-selected",
      function(value) {
        if (value) {
          this.cow = value;
          this.updateTable();
        }
      }.bind(this)
    );

    this.getBulls();
  },
  methods: {
    getBulls() {
      axios
        .get(serverAddress + "/api/wichrz/bulls", {
          auth: {
            username: "foo",
            password: "bar"
          }
        })
        .then(
          function(response) {
            this.bulls = response.data;
            console.log("pobralem!", this.bulls);
            //this.stopLoading();
            // this.showSuccessMessage();
          }.bind(this)
        )
        .catch(
          function(error) {
            //this.showErrorMessage(GET_COWS_SUCCESS_MESSAGE);
            ///this.stopLoading();

            console.log(error);
          }.bind(this)
        );
    },
    addInsemination() {
      if (!this.cow) {
        return;
      }
      if (this.cow.insemination == null) {
        this.cow.insemination = [];
      }

      let data = this.cow;
      if (this.sendInsemination) {
        if (!this.selectedBull) {
          return;
        }

        console.log("bull:", this.selectedBull);

        let date = new Date(this.inseminationDate);
        date = ('0' + date.getDate()).slice(-2) + '-'
             + ('0' + (date.getMonth()+1)).slice(-2) + '-'
             + date.getFullYear();

        data = {
          cow: this.cow,
          wichrz: {
            bull: this.selectedBull.value,
            date: date
          }
        };
      }

      this.cow.insemination.push(new Date(this.inseminationDate));
      this.updateTable();
      this.inseminationDate = new Date();

      bus.$emit("save-cow", data);
    },
    deleteInsemination() {
      if (this.currentRow !== null) {
        this.cow.insemination = this.cow.insemination.filter(
          function(item) {
            return (
              this.currentRow.insemination.getTime() != new Date(item).getTime()
            );
          }.bind(this)
        );

        this.updateTable();

        bus.$emit("save-cow", this.cow);
      }
    },
    formatter(row, column) {
      // console.log("row:", row, "column:", column.label, column.property)
      return row[column.property].toLocaleDateString(); //toISOString().slice(0, 10);
    },
    onCowSelected() {
      console.log("Wybrano krowe: ", this.cow);
      bus.$emit("cow-selected", this.cow);
    },
    updateTable() {
      var tableData = [];
      if (this.cow != null && this.cow.insemination != null) {
        this.cow.insemination.forEach(
          function(entry) {
            //  console.log(entry, "-", this.herdSettings.repetition);
            var entry = new Date(entry);
            var repeat = new Date(entry);
            var drying = new Date(entry);
            var calving = new Date(entry);

            repeat.setDate(entry.getDate() + this.herdSettings.repetition);
            drying.setDate(
              entry.getDate() +
                (this.herdSettings.pregnancy_length -
                  this.herdSettings.drying_up_time)
            );
            calving.setDate(
              entry.getDate() + this.herdSettings.pregnancy_length
            );

            tableData.push({
              insemination: entry,
              repeat: repeat,
              drying: drying,
              toclaving: calving
            });
          }.bind(this)
        );
      }
      this.inseminationsTableData = tableData;
    },
    handleErtus() {
      if (this.cow) {
        this.cow.estrus.is_during =
          this.cow.estrus.is_during === "Tak" ? "" : "Tak";

        this.cow.estrus.date = new Date();

        bus.$emit("save-cow", this.cow);
      }
    },
    handleCurrentChange(value) {
      this.currentRow = value;
    }
  }
};
</script>

<style>
.my-table {
  height: calc(100vh - 118px) !important;
}
</style>
